const initialState = {
  loading: false,
  error: null,
  message: null,
  articleDetails: null,
  keywordLoading: false,
  keywordError: null,
  keywordDetails: null,
  latestArticleList: null,
  latestArticleListLoading: null,
  latestArticleListError: null,
  categoryArticleList: null,
  updateArticleLoading: null,
  updateArticleError: null,
  updateCategoryLoading: null,
  updateCategoryError: null,
  category: null,
  articleAudio: null,
  submenu: null,
  submenuLoading: false,
  submenuError: null,
  downloadPdf: null,
  downloadPdfError: null,
  latestArticle: null,
};

const ArticleDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ARTICLE_DETAIL_SUCCESS":
      return {
        ...state,
        articleDetails: action.payload,
      };
    case "GET_ARTICLE_DETAIL_FAILURE":
      return {
        ...state,
        error: action.payload,
      };
    case "GET_KEYWORDS_REQUEST":
      return {
        ...state,
        keywordLoading: true,
      };
    case "GET_KEYWORDS_SUCCESS":
      return {
        ...state,
        keywordLoading: false,
        keywordDetails: action.payload,
      };
    case "GET_KEYWORDS_FAILURE":
      return {
        ...state,
        keywordLoading: false,
        keywordError: action.payload,
      };
    case "GET_SUBMENU_REQUEST":
      return {
        ...state,
        submenuLoading: true,
      };
    case "GET_SUBMENU_SUCCESS":
      return {
        ...state,
        submenuLoading: false,
        submenu: action.payload,
      };
    case "GET_SUBMENU_FAILURE":
      return {
        ...state,
        submenuLoading: false,
        submenuError: action.payload,
      };

    case "GET_LATEST_ARTICLES_REQUEST":
      return {
        ...state,
        latestArticleListLoading: true,
      };
    case "GET_LATEST_ARTICLES_SUCCESS":
      return {
        ...state,
        latestArticleListLoading: false,
        latestArticle: action.payload,
      };
    case "GET_LATEST_ARTICLES_FAILURE":
      return {
        ...state,
        latestArticleListLoading: false,
        latestArticleListError: action.payload,
      };
    case "GET_LATEST_ARTICLE_LISTING_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_LATEST_ARTICLE_LISTING_SUCCESS":
      return {
        ...state,
        loading: false,
        latestArticleList: action.payload,
      };
    case "GET_LATEST_ARTICLE_LISTING_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "UPDATE_LATEST_ARTICLE_LISTING_REQUEST":
      return {
        ...state,
        updateArticleLoading: true,
      };
    case "UPDATE_LATEST_ARTICLE_LISTING_SUCCESS":
      let updatedLatestArticleList = {};
      if (action.payload) {
        updatedLatestArticleList = state.latestArticleList;
        updatedLatestArticleList.data.results.push(
          ...action.payload.data.results
        );
        updatedLatestArticleList.data.current = action.payload.data.current;
        updatedLatestArticleList.data.itemsOnPage =
          action.payload.data.itemsOnPage;
        updatedLatestArticleList.data.next = action.payload.data.next;
        updatedLatestArticleList.data.previous = action.payload.data.previous;
      }
      return {
        ...state,
        updateArticleLoading: false,
        latestArticleList: updatedLatestArticleList,
      };
    case "UPDATE_LATEST_ARTICLE_LISTING_FAILURE":
      return {
        ...state,
        updateArticleLoading: false,
        updateArticleError: action.payload,
      };

    case "GET_CATEGORY_ARTICLE_LISTING_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_CATEGORY_ARTICLE_LISTING_SUCCESS":
      return {
        ...state,
        loading: false,
        categoryArticleList: action.payload.data.articles,
        category: action.payload.data.keyword,
      };
    case "GET_CATEGORY_ARTICLE_LISTING_FAILURE":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "UPDATE_CATEGORY_ARTICLE_LISTING_REQUEST":
      return {
        ...state,
        updateCategoryLoading: true,
      };
    case "UPDATE_CATEGORY_ARTICLE_LISTING_SUCCESS":
      let updatedCategoryArticleList = {};
      if (action.payload) {
        updatedCategoryArticleList = state.categoryArticleList;
        updatedCategoryArticleList.results.push(...action.payload.results);
        updatedCategoryArticleList.current = action.payload.current;
        updatedCategoryArticleList.itemsOnPage = action.payload.itemsOnPage;
        updatedCategoryArticleList.next = action.payload.next;
        updatedCategoryArticleList.previous = action.payload.previous;
      }
      return {
        ...state,
        updateCategoryLoading: false,
        categoryArticleList: updatedCategoryArticleList,
      };
    case "UPDATE_CATEGORY_ARTICLE_LISTING_FAILURE":
      return {
        ...state,
        updateCategoryLoading: false,
        updateCategoryError: action.payload,
      };

    case "CLEAR_CATEGORY_ARTICLE_LISTING":
      return {
        ...state,
        loading: false,
        categoryArticleList: null,
        error: null,
      };
    case "GET_ARTICLE_AUDIO_SUCCESS":
      return {
        ...state,
        articleAudio: action.payload,
      };
    case "GET_ARTICLE_AUDIO_FAILURE":
      return {
        ...state,
        articleAudio: action.payload,
      };
    case "POST_DOWNLOAD_PDF_SUCCESS":
      return {
        ...state,
        downloadPdf: action.payload,
      };
    case "POST_DOWNLOAD_PDF_FAILURE":
      return {
        ...state,
        downloadPdfError: action.payload,
      };
    case "CLEAR_DOWNLOAD_PDF":
      return {
        ...state,
        downloadPdf: action.payload,
      };

    default:
      return state;
  }
};

export default ArticleDetailReducer;
